/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@postscript/components';
import { Emoji } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import React from 'react';
import { Link } from 'react-router-dom';
import Events from '../../controllers/events';
import { feedbackLoops } from '../../providers';

const initialState = {
  modal: false,
};

class UpsellModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.manageFeedbackLoop = this.manageFeedbackLoop.bind(this);
    this.closeMe = this.closeMe.bind(this);
    this.upgradeMe = this.upgradeMe.bind(this);
  }

  componentDidMount() {
    Events.track('Viewed Upsell Modal');
    this.manageFeedbackLoop();
  }

  componentDidUpdate() {
    this.manageFeedbackLoop();
  }

  manageFeedbackLoop() {
    const { feedbackQueryParams } = this.props;
    let modalState = this.state.modal;
    // if the feedback loops are empty, there's nothing to evaluate
    if (!feedbackQueryParams || Object.keys(feedbackQueryParams).length < 1) {
      modalState = true;
    }
    for (const queryParam in feedbackQueryParams) {
      const queryValue = feedbackQueryParams[queryParam];
      // continue with a plan if necessary
      if (queryParam === 'charge_id' && queryValue) {
        modalState = false;
        break;
      }
    }
    // this really should be taken care of by the React LifeCycle
    // but since the App.js controls this, the check is best
    if (modalState != this.state.modal) {
      this.setState((state) => {
        return {
          ...state,
          modal: modalState,
        };
      });
    }
  }

  upgradeMe() {
    Events.track('Upsell Modal Upgrade Button Clicked');
    this.closeMe();
  }

  // The CL Modal has no `onClosed` post-animation lifecycle, so the cleanup
  // that reactstrap ran via `onClosed` now fires directly on close.
  closeMe() {
    Events.track('Closed Upsell Modal');
    this.props.closeModal();
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.state.modal} onCancel={this.closeMe}>
          <ModalHeader onCancel={this.closeMe}>
            Your credits are almost out!
            <Emoji emoji="money_with_wings" set="apple" size={32} />
          </ModalHeader>
          <ModalBody className="display-linebreaks">
            <div>
              Most of the credits for this month have already been used. At your
              current pace you will run out of credits soon, causing all
              automations and popup messages to pause and you to miss out on
              sales!
            </div>
            <br />
            <div>Upgrade your plan to prevent a pause on your messages.</div>
          </ModalBody>
          <ModalFooter>
            <Link to="/account/plan" onClick={this.upgradeMe}>
              <Button variant="primary">Upgrade Plan</Button>
            </Link>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

UpsellModal.propTypes = {};

export default feedbackLoops(UpsellModal, 'change_plan', 'charge_id', false);
